import { REFUND_DESTINATION_PROVIDERS } from "@redotech/redo-return-core-common/third-party-refunds/recipient";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { returnRefundDestinationSchema } from "../return-page-details/get-return-refund-destination";

export enum UpdateReturnRefundDestinationErrorCode {
  ReturnNotFound = "ReturnNotFound",
  /** The payout already started, or the team no longer offers the rail. */
  NotEditable = "NotEditable",
  InvalidRecipient = "InvalidRecipient",
}

export const updateReturnRefundDestination = {
  name: "updateReturnRefundDestination" as const,
  input: z.object({
    returnId: zExt.objectId(),
    provider: createEnum(REFUND_DESTINATION_PROVIDERS),
    recipient: z.object({
      email: z.string().nullish(),
      phone: z.string().nullish(),
    }),
  }),
  output: z.object({ destination: returnRefundDestinationSchema }),
};
